import { getLabelFromStorage } from '@pb/utils'

import { AddToBagVerificationLabels, ErrorProps } from '../../duck/types'

export const generalLabels = {
  priorPriceLabel: getLabelFromStorage('prior.price.label', { replacements: ' ' }),
  removeLabel: getLabelFromStorage('favorites.page.remove'),
  colorLabel: getLabelFromStorage('sidecart.color'),
  clubPriceLabel: getLabelFromStorage('club.price.text'),
}

export const storeSearchLabels = {
  storeSearchHeading: getLabelFromStorage('store.locator.modal.headline'),
  statusMessageText: getLabelFromStorage('store.locator.status.message'),
  storeAvailableSizesCopy: getLabelFromStorage('store.locator.available.sizes'),
  sizeNotMatchingErrorHeading: getLabelFromStorage('store.locator.no.matching.stores.headline'),
  sizeNotMatchingErrorDescription: getLabelFromStorage('store.locator.no.matching.sizes.bodytext'),
  showAllStoresButtonText: getLabelFromStorage('store.locator.show.all.sizes'),
  buyOnlineButtonText: getLabelFromStorage('store.locator.continue.online'),
  noStoresErrorHeading: getLabelFromStorage('store.locator.no.matching.sizes.headline'),
  noStoresErrorDescription: getLabelFromStorage('store.locator.no.matching.stores.bodytext'),
  openingHoursTitle: getLabelFromStorage('store.locator.opening.hours.headline'),
  openingHourExceptionsTitle: getLabelFromStorage(
    'store.locator.opening.hours.exceptions.headline',
  ),
  actionButtonTextStore: getLabelFromStorage('store.locator.trigger.store.information'),
  actionButtonTextMap: getLabelFromStorage('store.locator.directions.trigger'),
  singleStoreCustomerServiceText: getLabelFromStorage('store.locator.customer.service.trigger'),
  singleStoreCustomerServiceAriaLabel: getLabelFromStorage(
    'store.locator.customer.service.trigger.arialabel',
  ),
  singleStoreDirectionText: getLabelFromStorage('store.locator.directions.trigger'),
  singleStoreDirectionAriaLabel: getLabelFromStorage('store.locator.directions.trigger.arialabel'),
  singleStoreTabOneHeading: getLabelFromStorage('store.locator.trigger.store.information'),
  singleStoreTabTwoHeading: getLabelFromStorage('store.locator.trigger.map'),
  findInStoreTriggerText: getLabelFromStorage('find.in.store'),
  findInStoreTriggerAriaLabel: getLabelFromStorage('find.in.store.trigger.arialabel'),
  findInStoreNotAvailableText: getLabelFromStorage('find.in.store.not.available'),
  closeLabel: getLabelFromStorage('text.button.close'),
  articleCodeText: getLabelFromStorage('sidecart.art.no'),
  closeFullScreenIconText: getLabelFromStorage('text.button.back'),
  outOfStockCopy: getLabelFromStorage('favorites.size.outofstock'),
  stockToggleCopy: getLabelFromStorage('find.in.store.out.of.stock.toggle.text'),
  storeWithInCopy: getLabelFromStorage('store.locator.results.area'),
  size: getLabelFromStorage('favourites.size'),
  available: getLabelFromStorage('find.in.store.legend.available'),
  fewAvailable: getLabelFromStorage('find.in.store.legend.few.available'),
  locationNotMatchingText: getLabelFromStorage('commerce_search_searchnotmatchingpart1'),
}

export const miniCartLabels = {
  miniMiniCartLabel: getLabelFromStorage('cart.page.shopping.bag.sliding'),
  clubPriceLabel: getLabelFromStorage('club.price.text'),
  quantityLabel: getLabelFromStorage('sidecart.quantity'),
  sizeLabel: getLabelFromStorage('sidecart.size'),
  colorLabel: getLabelFromStorage('sidecart.color'),
  fewPiecesLeftLabel: getLabelFromStorage('favorites.bag.fewPieceLeft'),
  errorLabel: getLabelFromStorage('favorite.moveToBagErrorHeading'),
}

export const sizePickerLabels = {
  labelChooseSize: getLabelFromStorage('favorites.page.chooseSize'),
  labelSizeGuide: getLabelFromStorage('link.size.guide'),
  labelNIB: getLabelFromStorage('nib.notify.me'),
  labelNIBDescription: getLabelFromStorage('nib.notify.me.description'),
  labelMoveToCart: getLabelFromStorage('favorites.move.shopping.bag.button'),
  labelFewPiecesLeft: getLabelFromStorage('favorites.bag.fewPieceLeft'),
  labelComingSoon: getLabelFromStorage('coming.soon.size.selector'),
  labelOutOfStock: getLabelFromStorage('favorites.bag.outofstock'),
  labelClose: getLabelFromStorage('text.button.close'),
  labelMoveToCartAriaLabel: getLabelFromStorage('favorites.page.addtocart'),
  labelNIBAriaLabel: getLabelFromStorage('nib.notify.me.arialabel'),
  labelSizeNotSelected: getLabelFromStorage('pdp.boss.errormessage'),
}

export const sizeGuideLabels = {
  sizeGuide: getLabelFromStorage('sizeGuide.sizeGuide'),
  findMySize: getLabelFromStorage('sizeGuide.findMySize'),
  howToMeasure: getLabelFromStorage('sizeGuide.howToMeasure'),
  selectSizeRange: getLabelFromStorage('sizeGuide.selectSizeRange'),
  sizeGuideLinkText: getLabelFromStorage('sizeGuide.sizeGuideLinkText'),
  noSizeGuideTitle: getLabelFromStorage('sizeGuide.noSizeGuideTitle'),
  noSizeGuideDescription: getLabelFromStorage('sizeGuide.noSizeGuideDescription'),
  noSizeGuideClose: getLabelFromStorage('sizeGuide.noSizeGuideClose'),
}

export const energyLabelLabels = {
  energyDrawerTitle: getLabelFromStorage('favorites.energy.classification.title'),
  energyImageNumber: getLabelFromStorage('favorites.energy.classification.image.number'),
  hmName: getLabelFromStorage('general.hm'),
  hmLongName: getLabelFromStorage('general.hennes'),
}

export const addToBagVerificationLabels = (
  addToBagError: ErrorProps,
): AddToBagVerificationLabels => {
  return {
    errorLabel: addToBagError?.errorMessage || '',
    shoppingBagLabel: getLabelFromStorage('cart.page.shopping.bag'),
    goToShoppingBagLabel: getLabelFromStorage('cart.page.shopping.bag.goto'),
    addedToBagLabel: getLabelFromStorage('add.to.bag.verification.added.to.bag'),
    closeLabel: getLabelFromStorage('text.button.close'),
  }
}
